import moment from "moment-timezone";
import { useState, useEffect, useMemo } from "react";

const DIFF_TIME = 60000;
export const useTimeline = (timezone: TimeZone) => {
  const [nowValue, setNowValue] = useState(+new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setNowValue(+new Date());
    }, DIFF_TIME);
    return () => {
      clearInterval(timer);
    };
  }, [timezone]);

  const { startOfDay, time } = useMemo(() => {
    const startOfDay = moment(nowValue).tz(timezone).startOf("day");
    const time = {
      hour: moment(nowValue).tz(timezone).hours(),
      minutes: moment(nowValue).tz(timezone).minutes(),
    };
    return {
      startOfDay,
      time,
    };
  }, [nowValue, timezone]);

  return { startOfDay, time, nowValue };
};
